import React, { useMemo } from 'react';
import { PostItem } from '@components/Feed/Activities/Types/Post/PostItem';
import { DELETED_POST_MESSAGE } from '@utils/constants';
import type { ChannelPost } from './ChannelPosts';

export function ChannelPost({ post }: { post: ChannelPost }) {
  const timestamp = useMemo(() => new Date(post.createdAt).getTime(), [post.createdAt]);

  if (!post) {
    return <div className="text-base-s text-neutral400">{DELETED_POST_MESSAGE}</div>;
  }

  return (
    <PostItem
      post={post}
      postId={post.id}
      timeStamp={timestamp}
      repostSource={null}
      webappUri={post.webappUri}
      creator={post.creator}
      variant="channel"
    />
  );
}
